"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.get = function get(success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.get("/teams", null, responseHandler, "2.1");
};

module.exports.create = function create(team, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.post("/teams", team, responseHandler, "2.1");
};

module.exports.update = function update(team, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  var endpoint = "/teams/" + team.id;
  agendorAPI.put(endpoint, team, responseHandler, "2.1");
};

module.exports.delete = function del(team, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  var endpoint = "/teams/" + team.id;
  agendorAPI.del(endpoint, null, responseHandler, "2.1");
};

module.exports.createSync = function createSync(success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.post("/teams/sync", null, responseHandler, "2.1");
};

module.exports.getTeamErrorMessage = function getTeamErrorMessage(error, response) {
  var errorMessage = "Ocorreu um erro. Por favor, tente novamente mais tarde.";

  if (response.status == 500) { // Server Error
    errorMessage = "Ocorreu um erro. Por favor, tente novamente mais tarde.";
  } else if (response.status == 422) { // Unprocessable Entity
    errorMessage = "O usuário não pode ser líder dele mesmo.";
  } else if (response.status == 403) { // Forbidden
    errorMessage = "Função disponível somente para administradores da conta.";
  } else {
    var isBodyAnObject = error[0] !== null && typeof error[0] === "object";

    if (error.message) {
      errorMessage = error.message + ". Por favor, tente novamente mais tarde.";
    } else if (isBodyAnObject && "error" in error[0]) {
      if (error[0].error.match(/já está em uso/g)) {
        errorMessage = "Uma equipe com este nome já foi cadastrada.";
      }
    }
  }
  return errorMessage;
};



// WEBPACK FOOTER //
// ./app/util/api/team.js